import { render, staticRenderFns } from "./ProspectEchangeUpdate.vue?vue&type=template&id=0d0f6644"
import script from "./ProspectEchangeUpdate.vue?vue&type=script&lang=ts"
export * from "./ProspectEchangeUpdate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports